import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  ContentFeedNotification,
  NotificationFeedComponent
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { PushPipe } from '@ngrx/component';
import { BehaviorSubject } from 'rxjs';
import { NotificationFacadeService } from '../../data-access/facades/notification/notification-facade.service';
import { FlyoutSearchView } from '../../data-access/models/flyout/flyout-search.interfaces';
import { DeviceTypeService } from '../../data-access/services/device-type/device-type.service';
import { AnalyticsDataPopulateService } from '../../data-access/services/utils/analytics/analytics-data-populate/analytics-data-populate.service';
import { FlyoutPositionDirective } from '../../directive/flyout-position/flyout-position.directive';

@Component({
  selector: 'idp-notification',
  standalone: true,
  imports: [
    CommonModule,
    NotificationFeedComponent,
    PushPipe,
    FlyoutPositionDirective
  ],
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input() isAlertAdvisory = false;
  @ViewChild('notificationFlyoutDesktop')
  notificationFlyoutDesktop!: ElementRef;

  @ViewChild('notificationSearchMobile')
  notificationSearchMobile!: ElementRef;

  facade = inject(NotificationFacadeService);
  emptyNotificationDetails = {} as ContentFeedNotification;
  show = false;
  showModal: FlyoutSearchView = FlyoutSearchView.Desktop;
  flyoutNotification$ = new BehaviorSubject<boolean>(false);
  analyticsService = inject(AnalyticsDataPopulateService);
  constructor(private deviceTypeService: DeviceTypeService) {}

  @HostListener('window:resize') onResize() {
    if (this.show) {
      if (this.deviceTypeService.getDeviceType().isDesktop) {
        this.showModal = FlyoutSearchView.Desktop;
        this.notificationSearchMobile?.nativeElement?.close();
        this.notificationFlyoutDesktop.nativeElement.showModal();
      } else {
        this.showModal = FlyoutSearchView.Mobile;
        this.notificationFlyoutDesktop?.nativeElement?.close();
        this.notificationSearchMobile.nativeElement.showModal();
      }
    }
  }

  ngOnInit(): void {
    this.facade.init();
  }

  close(): void {
    this.show = false;
    this.notificationFlyoutDesktop?.nativeElement?.close();
    this.notificationSearchMobile?.nativeElement?.close();
  }

  open(): void {
    this.show = true;
    this.flyoutNotification$.next(true);

    this.showModal = this.deviceTypeService.getDeviceType().isDesktop
      ? FlyoutSearchView.Desktop
      : FlyoutSearchView.Mobile;

    setTimeout(() => {
      if (this.deviceTypeService.getDeviceType().isDesktop) {
        this.notificationFlyoutDesktop?.nativeElement?.showModal();
      } else {
        this.notificationSearchMobile?.nativeElement?.showModal();
      }
    });

    this.setFeedNotificationObjectAfterOpen();
  }

  setFeedNotificationObjectAfterOpen(): void {
    const visitedTodayDate: Date = new Date();
    const setFeedExpiryDate: Date = new Date();
    setFeedExpiryDate.setFullYear(setFeedExpiryDate.getFullYear() + 1);
    this.facade.feedNotificationObj.lastVisitedFeedAdvisories =
      visitedTodayDate;
    this.facade.feedNotificationObj.lastVisitedFeedExpiry = setFeedExpiryDate;
    this.facade.feedCounterValue = 0;
    this.facade.feedNotificationObj.feedCounterValue =
      this.facade.feedCounterValue;
    localStorage.setItem(
      'feedNotificationObj',
      JSON.stringify(this.facade.feedNotificationObj)
    );
  }

  analyticsEventTracking(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(element);
  }
}
